<template>
  <b-card class="shadow-sm" header-class="pl-2 card-header-inline" body-class="pt-0">
    <template v-slot:header>
      <BackButton
        class="mr-1"
        :redirect-to="backButtonRedirect"
      />
      <header class="pt-2">
        Komponen Nilai
      </header>
    </template>

    <DetailMatakuliah />

    <b-button-toolbar class="mb-4">
      <b-button-group class="mr-2">
        <AddButton
          :disabled="addButtonState"
          ref-button="KomponenPenilaianFormButton"
          title="Tambah Komponen Nilai"
          @add="addAssessComponent"
        />
      </b-button-group>
      <b-button-group>
        <TitleIconButton
          variant="outline-info"
          caption="Nilai Mahasiswa"
          tooltip-text="Halaman Nilai Mahasiswa"
          @onClick="redirectToStudentAssessment"
        >
          <template v-slot:icon>
            <assessment-icon></assessment-icon>
          </template>
        </TitleIconButton>
      </b-button-group>
    </b-button-toolbar>

    <b-modal
      id="KomponenPenilaianForm"
      centered
      hide-footer
      title="Form Komponen Penilaian"
      @close="closeForm"
    >
      <KomponenPenilaianForm @afterSave="afterSave" />
    </b-modal>

    <c-table
      primary-key="komPenId"
      foot-clone
      no-footer-sorting
      :table-data="items"
      :fields="captions"
      :loading="loading"
    >
      <template v-slot:cell(index)="{ index }">
        {{ index + 1 }}
      </template>

      <template v-slot:cell(komPenPersen)="{ item }">
        {{ item.komPenPersen }} %
      </template>

      <template v-slot:cell(action)="{ item }">
        <ActionButton
          :disabled="lectureCanManageComponent"
          title="Komponen Nilai"
          @edit="editAssessComponent(item)"
          @remove="removeAssessComponent(item)"
        />
      </template>

      <template v-slot:foot(index)>
        {{ '' }}
      </template>
      <template v-slot:foot(komPenNama)>
        {{ '' }}
      </template>
      <template v-slot:foot(action)>
        {{ '' }}
      </template>

      <template v-slot:foot(komPenPersen)>
        {{ totalPercentage }} %
      </template>
    </c-table>
  </b-card>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import { join, assessmentComponent, activeSemesterButtonState, equalSemester } from '@/helpers'
import {
  ModalMessageMixin, TableMixin,
  ActionButton, AddButton, BackButton, TitleIconButton,
  AssessmentIcon, Table as CTable
} from '@/components'
// module
import KomponenPenilaianForm from '@/modules/komponen/Form'
import DetailMatakuliah from '@/modules/matakuliah/Detail'

export default {
  name: 'KelolaKomponenNilai',
  mixins: [TableMixin, ModalMessageMixin],
  components: {
    AddButton,
    KomponenPenilaianForm,
    ActionButton,
    CTable,
    DetailMatakuliah,
    BackButton,
    TitleIconButton,
    AssessmentIcon
  },
  data () {
    return {
      activeSemesterButton: false,
      backButtonRedirect: {
        name: 'dosen.kelola-nilai'
      },
      studentAssessmentRoute: {
        name: 'dosen.mahasiswa-nilai',
        params: this.$route.params
      },
      fields: [
        { key: 'index', label: '#', sortable: true },
        { key: 'komPenNama', label: 'Nama Komponen', sortable: true },
        { key: 'komPenPersen', label: 'Persentase Komponen', sortable: true },
        { key: 'action', label: 'Aksi', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters({
      userDetail: 'users/getUserDetail',
      facultyId: 'faculty/getFacultyId',
      matakuliah: 'komponenPenilaian/getMatakuliah'
    }),
    ...mapState('assessment', {
      lectureCanEntry: 'lectureCanEntryAssessment'
    }),
    ...mapState('faculty', {
      activeSemester: 'activeSemesterId'
    }),
    ...mapState('komponenPenilaian', {
      currentSemester: 'semesterId',
      assessmentComponentExist: 'assessmentComponentExist',
      percentageReached: 'percentageReached',
      komponenPenilaian: 'komponenPenilaian',
      loading: 'loadingKomponenPenilaian'
    }),
    addButtonState () {
      if (this.lectureCanEntry === true) {
        return this.percentageReached === true
      }

      return true
    },
    activeSemesterState () {
      return activeSemesterButtonState(
        this.lectureCanEntry,
        this.activeSemesterButton,
        this.assessmentComponentExist
      )
    },
    lectureCanManageComponent () {
      return !(this.lectureCanEntry && this.activeSemesterButton)
    },
    totalPercentage () {
      if (this.tableData) {
        return assessmentComponent.totalPercentage(this.tableData)
      }

      return 0.00
    }
  },
  beforeMount () {
    Promise.all([
      this.getMatakuliah(this.$route.params.kelasId),
      this.setListKomponenPenilaian()
    ]).then(() => {
      this.tableDataProvider()
      this.activeSemesterButton = equalSemester(this.activeSemester, this.currentSemester)
    }).catch(err => {
      this.modalValidation(err)
    })
  },
  beforeDestroy () {
    this.flushGrantAccess()
  },
  methods: {
    ...mapMutations('komponenPenilaian', {
      setKomponenPenilaian: 'setKomponenPenilaian',
      setEditFormState: 'setEditFormState'
    }),
    ...mapActions({
      flushGrantAccess: 'assessment/flushGrantAccess',
      getMatakuliah: 'komponenPenilaian/getInfoMatakuliah',
      setListKomponenPenilaian: 'komponenPenilaian/setKomponenNilaiMaster',
      getAllKomponenNilai: 'komponenPenilaian/getAllKomponenNilai',
      destroyKomponenNilai: 'komponenPenilaian/destroyKomponenNilai'
    }),
    dataProvider () {
      return this.getAllKomponenNilai(this.$route.params.kelasId)
    },
    redirectToStudentAssessment () {
      return this.$router.push(this.studentAssessmentRoute)
    },
    closeForm () {
      this.setKomponenPenilaian({})
      this.setEditFormState(false)
    },
    afterSave () {
      this.closeForm()
      this.$bvModal.hide('KomponenPenilaianForm')
      this.tableDataProvider()
    },
    addAssessComponent () {
      this.$bvModal.show('KomponenPenilaianForm')
    },
    editAssessComponent (item) {
      this.setKomponenPenilaian(item)
      this.setEditFormState(true)
      this.$bvModal.show('KomponenPenilaianForm')
    },
    removeAssessComponent ({ komPenNama, komPenKlsId, komPenId }) {
      const confirmMessage = join('', ['Yakin hapus data [', komPenNama, '] ?'])
      const confirmModalConfig = {
        title: 'Hapus Komponen Penilaian',
        okVariant: 'danger',
        actionAfter: () => {
          this.destroyKomponenNilai({
            komPenId, komPenKlsId
          }).then(() => {
            this.tableDataProvider()
          })
        }
      }

      this.modalConfirmMessage(confirmMessage, confirmModalConfig)
    },
    modalValidation (errMsg) {
      this.modalMessage(errMsg.message, {
        noRedirect: true
      })
    }
  }
}
</script>

<style scoped>
.card-header-inline {
  display: inline-flex;
}
</style>
